import { useEntityDetailsDataStore } from '../use-entity-details-data-store';

export const useIncludedEntities = () => {
  const includedEntities = useEntityDetailsDataStore((state) => state.included);
  return includedEntities;
};
